import React from "react";
import { motion } from "framer-motion";

const HorecaHubMetaverseHeroSection = () => (
  <div className="text-center py-2 border-b border-green-500">
    <motion.h1
      className="text-lg lg:text-xl font-bold text-yellow-200 flex items-center px-4 py-2 gap-2"
      initial={{ opacity: 0, y: -30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
    >
      🌐 Think5Whys Khau Gali HORECA Metaverse
    </motion.h1>
    <motion.p
      className="text-sm text-white text-left w-full mx-auto"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.3, duration: 1 }}
    >
      A virtual ecosystem with Digital Twin in its roadmap connecting{" "}
      <strong>Owners</strong>, <strong>Customers</strong>,{" "}
      <strong>Suppliers</strong> and <strong>Government</strong>.
    </motion.p>
  </div>
);

export default HorecaHubMetaverseHeroSection;
